import React from "react";
import style from './Header.module.css'
import {Navbar} from "../navbar/Navbar";

export const Header = (props) => {
    return (
        
        <div className={style.contentWrapper}>

                <div className={style.information}>


                    <div className={style.myName}>
                            <h2>Артур Матвеев</h2>
                    </div>

                    <div className={style.badges}>
                        <img src="https://api.netlify.com/api/v1/badges/082aec48-da45-44ff-8dbd-ba6af28f4973/deploy-status" alt=""/>
                    </div>

                    <div className={style.prof}>
                        <h3>Junior Front-end developer</h3>
                    </div>
                </div>

                <div className={style.navigation}>


                    <Navbar history={props.history}/>

                    <div className={style.footer}>

                    </div>
                </div>

        </div>
    )
}